const t = "_root_1g2fs_1", o = "_zapCard_1g2fs_17", s = "_fullWidth_1g2fs_45", a = "_responsive_1g2fs_50", e = "_small_1g2fs_57", _ = "_large_1g2fs_62", n = "_topOfCard_1g2fs_73", g = "_imageContainer_1g2fs_83", r = "_withLargeImage_1g2fs_89", i = "_withAppIcons_1g2fs_99", c = "_serviceIconWrapper_1g2fs_106", l = "_metadataWrapper_1g2fs_116", p = "_title_1g2fs_134", f = "_titleWithProductTags_1g2fs_179", d = "_tag_1g2fs_212", h = "_tagIcons_1g2fs_219", m = "_tagText_1g2fs_226", C = "_hideOnMobile_1g2fs_231", I = "_skeletonRoot_1g2fs_239", W = "_bookmarkButtonContainer_1g2fs_244", b = "_tagLabel_1g2fs_256", k = {
  root: t,
  zapCard: o,
  fullWidth: s,
  responsive: a,
  small: e,
  large: _,
  topOfCard: n,
  imageContainer: g,
  withLargeImage: r,
  withAppIcons: i,
  serviceIconWrapper: c,
  metadataWrapper: l,
  title: p,
  titleWithProductTags: f,
  tag: d,
  tagIcons: h,
  tagText: m,
  hideOnMobile: C,
  skeletonRoot: I,
  bookmarkButtonContainer: W,
  tagLabel: b
};
export {
  k as s
};
//# sourceMappingURL=TemplateCard.module-BZzMrlV_.mjs.map
